export default "__VITE_ASSET__xS9eDrqV__"